<div class="flex gap-2">
  <mat-form-field class="w-full">
    <input matInput [type]="props.type || 'text'" [placeholder]="props.label!" [formControl]="formControl" />
  </mat-form-field>
  <button type="button" mat-raised-button color="primary" (click)="props.onButtonClick()" class="mt-2" [disabled]="props.disabled">
    {{ props.buttonLabel }}
  </button>
</div>
